import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { BarChart as RechartsBarChart, XAxis, YAxis, Legend as RechartsLegend, Bar as RechartsBar, Brush, Cell, Tooltip as RechartsTooltip, CartesianGrid, ResponsiveContainer, } from 'recharts';
import { getFromDefaultColors, getColor, mapGridOptions, CURSOR_BACKGROUND_COLOR } from './chartHelper';
import ChartTooltip from './ChartTooltip';
const BarChart = props => {
    const { width, height, data, dataUnit, dataKey, layout, legend, bars, xAxisOptions, yAxisOptions, gridOptions, showGrid, showXAxis, showYAxis, useDataColors, brush, tooltip } = props, remainingProps = __rest(props, ["width", "height", "data", "dataUnit", "dataKey", "layout", "legend", "bars", "xAxisOptions", "yAxisOptions", "gridOptions", "showGrid", "showXAxis", "showYAxis", "useDataColors", "brush", "tooltip"]);
    return (_jsx(ResponsiveContainer, { children: _jsxs(RechartsBarChart, Object.assign({ layout: layout, width: width, height: height, data: data }, remainingProps, { children: [showGrid && _jsx(CartesianGrid, Object.assign({ strokeDasharray: '3 3' }, mapGridOptions(gridOptions))), _jsx(XAxis, Object.assign({ hide: !showXAxis, dataKey: dataKey }, xAxisOptions)), _jsx(YAxis, Object.assign({ hide: !showYAxis, unit: dataUnit }, yAxisOptions)), legend && (_jsx(RechartsLegend, Object.assign({ payload: useDataColors &&
                        data.map((entry, index) => {
                            const legendColor = getColor(entry.color) || getFromDefaultColors(index);
                            return Object.assign(Object.assign({}, entry), { type: 'square', color: legendColor });
                        }) }, legend.props))), tooltip && _jsx(RechartsTooltip, Object.assign({ cursor: { fill: CURSOR_BACKGROUND_COLOR } }, tooltip.props)), bars.map(bar => {
                    const _a = bar.props, { dataUnit, color } = _a, remainingBarProps = __rest(_a, ["dataUnit", "color"]);
                    const cellColor = color && getColor(color);
                    return (_jsx(RechartsBar, Object.assign({ unit: dataUnit }, remainingBarProps, { fill: cellColor }, { children: useDataColors &&
                            data.map((entry, index) => {
                                const cellColor = getColor(entry.color) || getFromDefaultColors(index);
                                return _jsx(Cell, { fill: cellColor }, `cell-${index}`);
                            }) }), bar.key));
                }), brush && _jsx(Brush, { stroke: getColor('gray') })] })) }));
};
BarChart.defaultProps = {
    width: 480,
    height: 200,
    data: [],
    // dataUnit,
    // dataKey,
    layout: 'horizontal',
    // legend,
    bars: [],
    // xAxisOptions,
    // yAxisOptions,
    // gridOptions,
    showGrid: false,
    showXAxis: true,
    showYAxis: true,
    useDataColors: false,
    brush: false,
    tooltip: _jsx(ChartTooltip, {}),
    legend: false,
};
export default BarChart;
